import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit,Output,EventEmitter
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {WorkSpaceVMModel} from "../../models/WorkSpaceVMModel";
import {MarkerVMModel} from "../../models/MarkerModel";
import {SharingService} from "../../services/sharing/sharing.service";
import {ScheduleInfoDTO, WEEKDAYS, WorkDayVM} from "../../models/ServiceItemDetailVM";


@Component({

  selector: 'rw-company-header',  // <home></home>

  styles: [require('./company-header.component.css')],

  template: require('./company-header.component.html'),
  host: {
    '(window:resize)': 'onResize($event)'
  }

})
export class CompanyHeaderComponent implements OnInit,OnChanges {

  @Input() public companyKeyUrl? = null;
  companyDetail:CompanyVM;
  public coverImage:ImageVM;
  public imageUrl:String;
  mobileScreen:boolean = false;
  @Output() public onBookButtonClicked: EventEmitter<number> = new EventEmitter();
  themeHeaderType = 'MODERN_HEADER';
  /**
   * TypeScript public modifiers
   */
  constructor(private sharingService:SharingService, private router:Router, private activatedRoute:ActivatedRoute, private companyService:CompanyService) {

  }
  public imageList:ImageVM[];

  public ngOnInit() {
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }


  let parent=this;
    this.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((c)=> {
      this.companyDetail = c;
      this.getCompanyImageList(c);

      //اheader theme
      if(c.setting.themeSettingInfo.themeHeaderType)
        parent.themeHeaderType = c.setting.themeSettingInfo.themeHeaderType;
      else
        parent.themeHeaderType = 'MODERN_HEADER';
    })

  }

  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
  }


  getCompanyImageList(com:CompanyVM) {
    let parent = this;
    let hasDBImage = false;
    if (com && com.setting && com.setting.themeSettingInfo) {
      let albumid = com.setting.themeSettingInfo.albumInfoId;
      this.companyService.getAlbumImageList(albumid).subscribe((imageList)=> {
        if (imageList && imageList.length > 0 )
        {

          imageList.forEach((image)=> {
            if(image.sizeType == 'COVER_WIDE')
            {
              parent.coverImage = image;
              parent.imageUrl= parent.companyService.makeImageUrl('company',parent.coverImage,parent.companyDetail.activityType,false);
              hasDBImage = true;

            }
          })

          if(!hasDBImage)
          {
            parent.imageUrl= parent.companyService.makeImageUrl('company-wide',parent.coverImage,parent.companyDetail.activityType,false);
          }

        }
        else{
          parent.imageUrl= parent.companyService.makeImageUrl('company-wide',parent.coverImage,parent.companyDetail.activityType,false);
        }

      },(res)=>{
        parent.imageUrl= parent.companyService.makeImageUrl('company-wide',parent.coverImage,parent.companyDetail.activityType,false);
      })
    }
    else {
      parent.imageUrl= parent.companyService.makeImageUrl('company-wide',parent.coverImage,parent.companyDetail.activityType,false);
    }

  }

  shareCompanyUrl() {
    let url=this.companyService.getUrl();
    this.sharingService.copyToClipboard(url);
    //this.companyService.getCompanyfullWebSiteUrl().subscribe((url)=> {
    //  this.sharingService.copyToClipboard(url);
    //})

  }

  onResize(event){
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }
  }

  bookButtonClick(){
    this.onBookButtonClicked.emit();
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/company-header/company-header.component.ts